export default defineNuxtRouteMiddleware((to, from) => {
  if (!import.meta.server) {
    return
  }
  const store = useNuxtApp().$store as any
  const headers = useRequestHeaders()
  if (headers.host) {
    store.dispatch('setHostName', headers.host)
  }
})